import React from 'react'
import { ClinicSidebar } from './ClinicSidebar'
import { useLocation } from 'react-router-dom'
import { ClinicView } from '../components/shared/clinics/ClinicView'
import { ClinicEdit } from '../components/shared/clinics/ClinicEdit'
import { ClinicStatus } from '../components/shared/clinics/ClinicStatus'
import { ClinicNotification } from '../components/shared/clinics/ClinicNotification'

export const Clinic = () => {
    const { pathname } = useLocation()
    return (
        <div className='flex gap-2 justify-between w-full '>
            <div className='w-[15%] min-h-[80vh]'>
                <ClinicSidebar />
            </div>
            <div className='w-[80%] min-h-[80vh] '>
                {pathname.includes('/edit')
                    ? <ClinicEdit />
                    : (pathname.includes('/status')
                        ? <ClinicStatus />
                        : (pathname.includes('/notification')
                            ? <ClinicNotification />
                            : <ClinicView />
                        )
                    )
                }
            </div>
        </div>
    )
}
